import React from 'react'
import {useDrag} from 'react-dnd'
import {ElementoRMLSelezionabileRecord} from "@commons/mapping/ElementoRMLSelezionabileRecord";
import {ItemTypes} from "../../../../core/DnDItemTypes";
import {useUpdateMutation} from "@commons/features/lavoratore/elemitiRMLSelezionati.api";
import {MutationError} from "../../../../core/editor";
import BasicBadge from "../../../../components/BasicBadge";
import {DettaglioRetribuzioneRecord} from "@commons/mapping/DettaglioRetribuzioneRecord";
import {toastAsError} from "@utilities/toastAsError";

interface DropResult {
    name: string
}

const ElementoRML4Drag: React.FC<{
    elemento: ElementoRMLSelezionabileRecord,
    type: string,
    setElementiSelezionabili: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>,
    setElementiSelezionati: React.Dispatch<React.SetStateAction<ElementoRMLSelezionabileRecord[]>>
}> = ({elemento, type, setElementiSelezionabili, setElementiSelezionati}) => {

    const [updateTrigger, updateResult] = useUpdateMutation();

    const [{isDragging}, drag] = useDrag(() => ({
        type: type,
        item: elemento,
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult<DropResult>()
            if (item && dropResult) {
                //alert(`You dropped ${item.elemento.descrizione} into ${dropResult.name}!`)
                const elemento = item;//.elemento;
                let selezionato;
                if (type === ItemTypes.ELEMENTO_RML_UNSELECTED) {
                    console.log("abilito voce", item.descrizione);
                    selezionato = true;
                } else {
                    console.log("disabilito voce", item.descrizione);
                    selezionato = false;
                }
                updateTrigger({...item, selezionato})
                    .unwrap()
                    .then(() => {
                        setElementiSelezionabili((v) => v.filter(obj => obj.codElemento !== elemento.codElemento));
                        setElementiSelezionati((v) => v.concat([elemento]));
                    })
                    .catch((error: MutationError) => {
                        // @ts-ignore
                        const message = error.data.message;
                        toastAsError(message);
                    })
            }
        },

        collect: monitor => ({
            isDragging: !!monitor.isDragging(),
        }),
    }))

    return (
        <div ref={drag} className={`text-ellipsis overflow-hidden cursor-move whitespace-nowrap my-1 first:!mt-0` + (isDragging ? 'opacity-5' : 'opacity-0')}>
            <BasicBadge label={elemento.descrizione! + ' [#' + elemento.codElemento + ']'} type={"custom"}
                        containerClass={`text-sm${elemento.elementoDiscrezionale ? ' border border-red-600' : ''}`}
                        customStyle={{bg: `${DettaglioRetribuzioneRecord.getStyle(elemento.tipo).bg}`, text: "text‑current"}}></BasicBadge>
        </div>
    )
}

export default ElementoRML4Drag